import { StatsApiClient } from "../../clients/stats-client";
import { UpdateModel, UpdatesHistory } from "./models/updates";

export class UpdatesRepository {
    private _statsClient: StatsApiClient;

    constructor() {
        this._statsClient = new StatsApiClient('/api/v2/updates');
    }

    async getHistory(page: number, valuesOnPageCount: number): Promise<ApiPaginationResponse<UpdatesHistory>> {
        return await this._statsClient.getWithPagination<UpdatesHistory>("", page, {}, valuesOnPageCount);
    }

    async get(url: string): Promise<ApiDataResponse<UpdateModel>> {
        return await this._statsClient.get<UpdateModel>(url);
    }
}